export const FETCH_TRACK_REQUEST = "FETCH_TRACK_REQUEST";
export const FETCH_TRACK = "FETCH_TRACK";

export const RELOAD_CURRENT_TRACK = "RELOAD_CURRENT_TRACK";
